import React, { useContext, useEffect, useState } from 'react'
import { getImages, teamImages } from '../components/Common/const'
import { VehicleContext } from '../components/Context/VehicleContext';

const departments = ['Leadership', 'Sales', 'Service', 'Operations', 'Accounting & Titling', 'Detailing', 'Mark Customs'];


const OurTeam = () => {

    const {getTeamMembers} = useContext(VehicleContext);

    const [teamMembers, setTeamMembers] = useState([]);

    const fetchTeamMembers = async () => {
        const data = await getTeamMembers();

        console.log(data);
    
        setTeamMembers(data);
    }
      
    useEffect(() => {
        fetchTeamMembers();
    },[]);

    useEffect(() => {

    },[])

    const [location, setLocation] = useState("all");
    const [isMobile, setIsMobile] = useState(window.innerWidth < 767);

    const filterItem = (location) => {
        setLocation(location);
    };


    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <section className='team-wrap common-wrap'>
                <div className='container'>
                    <div className='d-flex align-items-center justify-content-between mb-5 team-header-flex'>
                        <div className='lg-title text-uppercase wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">Our Team</div>
                        <ul className='tab-list d-flex align-items-center wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.6s">
                            <li>
                                <button type='button'
                                    onClick={() => filterItem("all")}
                                    className={location === "all" ? "active" : ""}
                                >
                                    All
                                </button>
                            </li>
                            <li>
                                <button type='button'
                                    onClick={() => filterItem("Boerne")}
                                    className={location === "Boerne" ? "active" : ""}
                                >
                                    Boerne
                                </button>
                            </li>
                            <li>
                                <button type='button'
                                    onClick={() => filterItem("Austin")}
                                    className={location === "Austin" ? "active" : ""}
                                >
                                    Austin
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <div className="accordion team-accordion" id="accordionExample">
                            {departments.map((category, idx) => {
                                const teamList = teamMembers.filter(item => item.department == category && (location == "all" || item.location == location));
                                

                                return teamList.length > 0 ? (<div className="accordion-item" key={idx}>
                                    <h2 className="accordion-header  wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                                        <button
                                            className={`accordion-button fw-500 text-uppercase ps-5 ${isMobile ? idx !== 0 ? 'collapsed' : '' : ''}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse-${category.toLowerCase().replace(/ & /g, ' and ').replace(/\s+/g, '-')}`}
                                            aaria-expanded={!isMobile && idx === 0 ? 'true' : 'false'}
                                            aria-controls={`collapse-${category.toLowerCase().replace(/ & /g, ' and ').replace(/\s+/g, '-')}`}
                                        >
                                            {/* {console.log("category", category)} */}
                                            {category.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())}
                                            {["service", "detailing", "mark customs"].includes(category.toLowerCase()) &&
                                                // active !== "all" && (
                                                    <span className="fw-300 ps-2 d-inline-block">(Boerne)</span>
                                                // )
                                            }
                                            {/* {(active !== "all" && (
                                                <span className="fw-300 ps-2 d-inline-block">({active})</span>
                                            )} */}
                                        </button>
                                    </h2>
                                    <div
                                        id={`collapse-${category.toLowerCase().replace(/ & /g, ' and ').replace(/\s+/g, '-')}`}
                                        className={`accordion-collapse collapse ${isMobile ? idx === 0 ? 'show' : '' : 'show'}`}
                                        {...(isMobile ? { 'data-bs-parent': '#accordionExample' } : {})}
                                    >
                                        <div className="accordion-body">
                                            <div className="d-flex flex-wrap team-flex">
                                                {teamList.map((item, index) => (
                                                    <div className="team-col wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s" key={index}>
                                                        <div className="team-box w-100">
                                                            <div className="team-image">
                                                                <img
                                                                    src={item.photo_url ? item.photo_url : teamImages('./no-photo.png')}
                                                                    alt={item.full_name}
                                                                />
                                                            </div>
                                                            <div className="team-content">
                                                                <div className="xs-title font-1-1em fw-500 text-white text-uppercase mt-4 mb-0">
                                                                    {item.full_name}
                                                                </div>
                                                                <div className="xs-title fw-400 text-white opacity-0-5">
                                                                    {item.position}
                                                                </div>
                                                                <div className='d-flex align-items-center justify-content-between mt-2 px-3'>
                                                                    <div className="text-start">
                                                                        {item.phone && (
                                                                            <a href={`tel:${item.phone}`} className="text-blue d-inline-block px-1">
                                                                                <span className="call-icon">
                                                                                    <img src={getImages('call.png')} alt="call" />
                                                                                </span>
                                                                            </a>
                                                                        )}
                                                                        {item.email && (
                                                                            <a href={`mailto:${item.email}`} className="text-blue d-inline-block envelope-text px-1">
                                                                                <i className="bi bi-envelope-fill"></i>
                                                                            </a>
                                                                        )}
                                                                    </div>
                                                                    <div className='xs-title fw-400 text-white font-15'>{item.location}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                ) : (<div key={idx}></div>);
                            })}
                        </div>
                    </div>
                    <div className='text-center mt-4 mm-logo'>
                        <img src={getImages('mm-logo-white.png')} />
                    </div>
                </div>
            </section>
        </>
    )
}

export default OurTeam